import createReactComponent from '../createReactComponent';
export default createReactComponent('box-model-off', 'IconBoxModelOff', [
  ['path', { d: 'M12 8h4v4m0 4h-8v-8', key: 'svg-0' }],
  [
    'path',
    {
      d: 'M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405',
      key: 'svg-1',
    },
  ],
  ['path', { d: 'M16 16l3.3 3.3', key: 'svg-2' }],
  ['path', { d: 'M16 8l3.3 -3.3', key: 'svg-3' }],
  ['path', { d: 'M8 8l-3.3 -3.3', key: 'svg-4' }],
  ['path', { d: 'M8 16l-3.3 3.3', key: 'svg-5' }],
  ['path', { d: 'M3 3l18 18', key: 'svg-6' }],
]);
